import { CustomListKey } from "./custom-list";
export const inboundLeadClientTypes = ["placement", "homeCare"];
export function statusListKeyForInboundLeadClientType(clientType) {
    switch (clientType) {
        case "placement":
            return CustomListKey.ClientStatus;
        case "homeCare":
            return CustomListKey.HomeCareLeadStatus;
        default: {
            const exhaustiveCheck = clientType;
            throw new Error(`Unhandled client type: ${exhaustiveCheck}`);
        }
    }
}
export function newStatusKeyForInboundLeadClientType(clientType) {
    switch (clientType) {
        case "placement":
            return "new";
        case "homeCare":
            return "hcInquiry";
        default: {
            const exhaustiveCheck = clientType;
            throw new Error(`Unhandled client type: ${exhaustiveCheck}`);
        }
    }
}
export function resolveStartingStatus(items, clientType, preferred) {
    const preferredItem = items.find(item => item.id === preferred);
    if (preferredItem && !preferredItem.isArchived) {
        return preferredItem.id;
    }
    const newStatusKey = newStatusKeyForInboundLeadClientType(clientType);
    const newStatus = items.find(item => item.key === newStatusKey);
    if (newStatus && !newStatus.isArchived) {
        return newStatus.id;
    }
    const selectable = items.filter(item => !item.isArchived);
    if (selectable.length === 0) {
        return null;
    }
    return selectable.reduce((lowest, item) => item.order < lowest.order ? item : lowest).id;
}
//# sourceMappingURL=inbound-lead.js.map